import { useTargetMbox } from '@webmotors/anunciar.tools';

import { MyAdsPage } from '@/page/v1/my-ads';

const MBOX_NAME = 'mbox-garagem-meus-anuncios';
const MBOX_KEY = 'garagem_meus_anuncios';

const MyAdsRenderer = () => {
	const { variation } = useTargetMbox<string>({
		mbox: MBOX_NAME,
		key: MBOX_KEY,
		run: MBOX_NAME.length > 0,
	});

	// Renderiza v1 imediatamente — a página tem seu próprio header + tabs +
	// skeleton internos, então o usuário vê o chrome (incluindo "Ativos /
	// Em análise / Inativos / Incompletos") logo de cara e as contagens
	// preenchem conforme as queries resolvem.
	// Quando v2 existir, renderizar <MyAdsV2 /> quando variation === 'B'.
	if (variation === 'B') return <MyAdsPage />;

	return <MyAdsPage />;
};

MyAdsRenderer.displayName = 'MyAdsRenderer';
export { MyAdsRenderer };
